import axios from 'axios';

export const API_ROOT = (process.env.REACT_APP_API_URL || 'http://localhost:8000/api/v1').replace(/\/$/, '');
export const BACKEND_ROOT = API_ROOT.replace(/\/api\/v1$/, '');

const api = axios.create({
  baseURL: API_ROOT,
  headers: { Accept: 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('melati_jwt');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original?._retried && localStorage.getItem('melati_jwt')) {
      original._retried = true;
      try {
        const { data } = await axios.post(`${API_ROOT}/auth/refresh`, {}, {
          headers: { Authorization: `Bearer ${localStorage.getItem('melati_jwt')}` },
        });
        const token = data.data?.authorization?.token;
        if (token) {
          localStorage.setItem('melati_jwt', token);
          original.headers.Authorization = `Bearer ${token}`;
          return api(original);
        }
      } catch (_) {
        localStorage.removeItem('melati_jwt');
        localStorage.removeItem('melati_user');
      }
    }
    return Promise.reject(error);
  },
);

export const assetUrl = (path) => {
  if (!path) return '';
  if (/^https?:\/\//.test(path)) return path;
  return `${BACKEND_ROOT}/storage/${String(path).replace(/^\//, '')}`;
};

export const apiError = (error) => {
  const errors = error.response?.data?.errors;
  if (errors) return Object.values(errors).flat().join(' ');
  return error.response?.data?.message || error.message || 'Terjadi kesalahan.';
};

export default api;
